import React from 'react';
import './NotificationPermissionModal.css';

interface NotificationPermissionModalProps {
  onAllow: () => void;
  onDeny: () => void;
  onLater: () => void;
  /** M14 FIX (Mission 35B): 'recovery' mode shows browser settings guidance
   *  when permission was previously denied. Default is 'request' (first-time). */
  mode?: 'request' | 'recovery';
}

export const NotificationPermissionModal: React.FC<NotificationPermissionModalProps> = ({
  onAllow,
  onDeny,
  onLater,
  mode = 'request'
}) => {
  const isRecovery = mode === 'recovery';

  return (
    <div className="notification-permission-overlay" onClick={onLater}>
      <div className="notification-permission-modal" onClick={(e) => e.stopPropagation()}>
        <div className="permission-modal-header">
          <div className="permission-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <h3>{isRecovery ? 'Notifications are blocked' : 'Stay Connected with Coach Cedar'}</h3>
        </div>

        <div className="permission-modal-content">
          {isRecovery ? (
            <>
              <p>
                Browser notifications are currently blocked. To receive workout reminders and coaching check-ins, you can re-enable them in your browser settings.
              </p>
              <div className="permission-benefits">
                <div className="benefit-item">
                  <span className="benefit-icon">1.</span>
                  <span>Click the lock icon in your browser address bar</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">2.</span>
                  <span>Find "Notifications" and change to "Allow"</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">3.</span>
                  <span>Refresh this page</span>
                </div>
              </div>
            </>
          ) : (
            <>
              <p>
                Get gentle daily check-ins and coaching reminders to help you stay on track with your health goals.
              </p>
              <div className="permission-benefits">
                <div className="benefit-item">
                  <span className="benefit-icon">&#x23F0;</span>
                  <span>Daily check-ins at your preferred time</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">&#x1F3AF;</span>
                  <span>Gentle reminders for your goals</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">&#x1F512;</span>
                  <span>Privacy-focused (no tracking or ads)</span>
                </div>
              </div>
              <p className="permission-note">
                You can customize or turn off notifications anytime in Settings.
              </p>
            </>
          )}
        </div>

        <div className="permission-modal-actions">
          {isRecovery ? (
            <button
              className="allow-notifications-button"
              onClick={onLater}
            >
              Got it
            </button>
          ) : (
            <>
              <button
                className="allow-notifications-button"
                onClick={onAllow}
              >
                Allow Notifications
              </button>
              <div className="secondary-actions">
                <button
                  className="later-button"
                  onClick={onLater}
                >
                  Maybe Later
                </button>
                <button
                  className="no-thanks-button"
                  onClick={onDeny}
                >
                  No Thanks
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}; 